import WorkReceipt from "../components/WorkReceipt/WorkReceipt";

function WorkReceiptPage(props) {
  return (
    <div className="col-12">
      <WorkReceipt {...props} />
    </div>
  );
}

export default WorkReceiptPage;
